(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener('change', function(event) { if (!event.target.matches('select[id^="Variant-"]')) return; const price = document.getElementById(event.target.id.replace('Variant-', 'ProductPrice-')); if (price) price.textContent = event.target.selectedOptions[0].dataset.price; });

  } catch(e) { console.error(e); }
})();
})();
